import { Box, Stack } from "@dropbox/dig-foundations";
import { EditUserProfileBody } from "@mirage/mosaics/UserProfilePage/EditUserProfileBody";
import { UserProfileAvatar } from "@mirage/mosaics/UserProfilePage/UserProfileAvatar";
import { UserProfileBackgroundImage } from "@mirage/mosaics/UserProfilePage/UserProfileBackgroundImage";
import { UserProfileBody } from "@mirage/mosaics/UserProfilePage/UserProfileBody";
import { UserProfileHeader } from "@mirage/mosaics/UserProfilePage/UserProfileHeader";
import {
  UserProfileName,
  UserProfileRole,
} from "@mirage/mosaics/UserProfilePage/UserProfileInfo";
import { useLocation } from "react-router-dom";

import type { UserInfo } from "@mirage/mosaics/UserProfilePage/types";
import baseStyles from "../BaseProfilePage/BaseProfilePage.module.css";

export const UserProfilePageLayout = ({
  user,
  isEdit,
}: {
  user: UserInfo;
  isEdit: boolean;
}) => {
  const location = useLocation();

  return (
    <Box as="div" className={baseStyles.pageContainer}>
      <Box as="div" className={baseStyles.contentContainer}>
        <UserProfileHeader
          user={user}
          showBackButton={!!location.state?.source}
          isEdit={isEdit}
        />
        <Stack width="100%">
          <UserProfileBackgroundImage />
          <Box
            style={{
              marginTop: "-92px",
              display: "flex",
              flexDirection: "column",
              paddingLeft: "102px",
            }}
            paddingBottom="8"
          >
            <UserProfileAvatar user={user} size="profile" />
            <Box
              display="flex"
              flexDirection="column"
              style={{ maxWidth: "736px" }}
            >
              <UserProfileName user={user} />
              <Box marginBottom="24">
                <UserProfileRole user={user} />
              </Box>
              {isEdit ? (
                <EditUserProfileBody user={user} />
              ) : (
                <UserProfileBody user={user} />
              )}
            </Box>
          </Box>
        </Stack>
      </Box>
    </Box>
  );
};
